<template lang="pug">
.filtered-notification(v-if="showCounts")
  .filtered-notification__used-filter {{ selectedFilterText }}
  .filtered-notification__filtered {{ text }}
</template>

<script setup>
import { computed } from "vue";
import { dynamicIssuesLocales } from "@/services/useLocales";

const props = defineProps({
  /*
  Показываем ли числа фильтров (настраивается с бека)
  */
  showCounts: { type: Boolean, default: false },
  /*
  Проп содержащий объект примененного фильтра. { label: Text }
  Отвечает за текст примененного фильтра selectedFilterText
  */
  selectedFilter: { type: Object, default: () => ({}), required: false },
  /*
  Проп содержащий количество отфильтрованного { filtered: Number, total: Number }
  */
  counts: { type: [Object, Number], default: () => ({}), required: false },
});

const currentLocales = computed(() => dynamicIssuesLocales.value);

const normalizeCount = value => {
  const numberValue = Number(value);

  return Number.isNaN(numberValue) ? 0 : numberValue;
};

const normalizedCounts = computed(() => {
  if (typeof props.counts === "number") {
    return {
      filtered: props.counts,
      total: props.counts,
    };
  }

  const filtered = normalizeCount(props.counts?.filtered ?? props.counts?.count ?? props.counts?.total ?? 0);
  const total = normalizeCount(props.counts?.total ?? props.counts?.filtered ?? props.counts?.count ?? 0);

  return { filtered, total };
});

const text = computed(() =>
  normalizedCounts.value.total !== normalizedCounts.value.filtered
    ? `${currentLocales.value["counts"].filtered} ${normalizedCounts.value.filtered} ${currentLocales.value["counts"].from} ${normalizedCounts.value.total}`
    : `${currentLocales.value["counts"].total}: ${normalizedCounts.value.total}`,
);

const selectedFilterText = computed(() => {
  // форматирует текст и добавляет имя примененного фильтра

  if (props.selectedFilter?.value) {
    const appliedFilter = currentLocales.value["filters"].applied_filter;
    const filterName = props.selectedFilter.label;

    const filterNameFirstLetterUppercase = filterName.charAt(0).toUpperCase() + filterName.slice(1); // первая буква большая, остальные маленькие

    return `${appliedFilter}: ${filterNameFirstLetterUppercase}`;
  } else {
    return "";
  }
});
</script>

<style scoped lang="scss">
.filtered-notification {
  display: flex;
  justify-content: space-between;

  &__filtered {
    color: #b5bbc9;
    text-transform: lowercase;

    &::first-letter {
      text-transform: capitalize;
    }
  }
  &__used-filter {
    color: #b5bbc9;

    &::first-letter {
      text-transform: capitalize;
    }
  }
}
</style>
